<template>
  <SectionContainerPage>
    <SectionModelList
      :modelList="modelList"
      :categoryList="categoryList"
      :manufacturerList="manufacturerList"
      :shouldShowSearch="true"
      :toolbarActions="[
        {
          text: 'Model',
          icon: 'add',
          iconColor: 'success',
          emitEvent: 'onAddNewModelClicked',
        },
      ]"
      @onAddNewModelClicked="showDialogFormModelAdd = true"
      @onEditModelClicked="
        (val) => [
          (modelToEdit = val.modelToEdit),
          (showDialogFormModelEdit = true),
        ]
      "
      :isLoading="isLoading"
    />
    <DialogFormModelAdd
      :showDialog="showDialogFormModelAdd"
      @onCancelClicked="showDialogFormModelAdd = false"
      @onSubmitClicked="(val) => [onDialogFormModelAddSubmit(val)]"
      :categoryList="categoryList"
      :manufacturerList="manufacturerList"
      :isLoading="isLoading"
    />
    <DialogFormModelEdit
      :showDialog="showDialogFormModelEdit"
      :modelToEdit="modelToEdit"
      @onCancelClicked="showDialogFormModelEdit = false"
      @onSubmitClicked="(val) => [onDialogFormModelEditSubmit(val)]"
      :categoryList="categoryList"
      :manufacturerList="manufacturerList"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionModelList from './sections/SectionModelList'
import DialogFormModelAdd from '../dialogs/DialogFormModelAdd'
import DialogFormModelEdit from '../dialogs/DialogFormModelEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

export default {
  components: {
    SectionContainerPage,
    SectionModelList,
    DialogFormModelAdd,
    DialogFormModelEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {},
  data: () => ({
    showDialogFormModelAdd: false,
    showDialogFormModelEdit: false,
    isLoadingCount: 0,
    modelToEdit: {},
    modelList: [],
    categoryList: [],
    manufacturerList: [],
  }),
  activated() {
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onDialogFormModelAddSubmit(data) {
      this.isLoadingCount++
      this._insertModel({
        name: data.name,
        categoryId: data.categoryId,
        manufacturerId: data.manufacturerId,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormModelAdd = false
          this.fetchLists()
          this.$emit('notify', { message: 'Model successfully created!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormModelEditSubmit(data) {
      this.isLoadingCount++
      this._updateModel({
        id: data.id,
        name: data.name,
        categoryId: data.categoryId,
        manufacturerId: data.manufacturerId,
        isEnabled: data.isEnabled,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormModelEdit = false
          this.fetchLists()
          this.$emit('notify', { message: 'Model successfully updated!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: ['Model', 'Category', 'Manufacturer'],
        successCb: (data) => {
          this.isLoadingCount--
          this.modelList = data.models
          this.categoryList = data.categories
          this.manufacturerList = data.manufacturers
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.categoryList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
